export default __webpack_public_path__ + "static/media/736.13ecfe3e.png";